import React, { useState } from "react";
import validator from "validator";
import { useTranslation } from "react-i18next";
import Alert from "./../Alert";
import configVars from "../../config";

const AddNewCompany = (props) => {
  const [organizationName, setOrganizationName] = useState("");
  const [ownerEmail, setOwnerEmail] = useState("");
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [translation] = useTranslation("translations");
  const [ownerName, setOwnerName] = useState('');
  const [ownerMembership, setOwnerMembership] = useState(0);

  const handleAddCompany = async (event) => {
    event.preventDefault();

    setIsError(false);
    setSuccess(false);
    setErrorMsg("");

    const validation = handleValidation(organizationName, ownerEmail);

    if (!validation.isValidated) {
      setIsError(true);
      setErrorMsg(validation.validationMsg);

      return;
    }

    setSaving(true);

    const response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/addneworganization/?organization=${encodeURIComponent(organizationName)}&email=${encodeURIComponent(ownerEmail)}&name=${encodeURIComponent(ownerName)}&membership=${encodeURIComponent(ownerMembership)}`,
      {
        method: "GET",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
        },
      }
    );

    const companyResponse = await response.json();

    if (companyResponse) {
      if (companyResponse.success === true) {
        setSuccess(true);
        setErrorMsg(
          "Successfully created the organization and added the owner to the organization"
        );
      } else {
        setIsError(true);
        setErrorMsg(companyResponse.message);
      }

      setOrganizationName("");
      setOwnerEmail("");

      //console.log( companyResponse );
    }

    setSaving(false);
  };

  const handleValidation = (organization, ownerEmail) => {
    let isValidated = true;
    let validationMsg = "";

    if (!organization.toString().trim().length) {
      isValidated = false;
      validationMsg = translation("fill_required_fields");
    }

    if (!validator.isEmail(ownerEmail)) {
      isValidated = false;
      validationMsg = translation("enter_valid_email");
    }

    return {
      isValidated: isValidated,
      validationMsg: validationMsg,
    };
  };

  return (
    <div className="add-new-user-wrap">
      <h3 className="mb-4">Add new organization</h3>
      <form
        style={{ maxWidth: "800px" }}
        onSubmit={(event) => handleAddCompany(event)}
      >
        {isError && (
          <div className="mt-3" style={{ maxWidth: "800px" }}>
            <Alert type="danger" msg={errorMsg} />
          </div>
        )}

        {success && (
          <div className="mt-3" style={{ maxWidth: "800px" }}>
            <Alert type="success" msg={errorMsg} />
          </div>
        )}

        <div className="row mb-3 user-row">
          <div className="col-12 col-lg-6">
            <input
              type="text"
              className="form-control"
              placeholder="Organization name"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
            />
          </div>
          <div className="col-12 col-lg-6">
            <input
              type="email"
              className="form-control"
              placeholder="Organization owner email"
              value={ownerEmail}
              onChange={(e) => setOwnerEmail(e.target.value)}
            />
          </div>
        </div>

        <div className="row mb-3 user-row">
          <div className="col-12 col-lg-6">
            <input
              type="text"
              className="form-control"
              placeholder="Owner Name"
              value={ownerName}
              onChange={(e) => setOwnerName(e.target.value)}
            />
          </div>
          <div className="col-12 col-lg-6">
          <div className="row">
              <div className="col">
                <select
                  className="form-select"
                  aria-describedby="companyHelp"
                  value={ownerMembership}
                  onChange={(e) => setOwnerMembership(e.target.value)}
                >
                  {props?.loadingMemberships && (
                    <option value="0">Loading memberships...</option>
                  )}
                  {!props?.loadingMemberships && (
                    <option value="0">Select user membersip plan</option>
                  )}

                  {props?.allMemberships &&
                    props?.allMemberships.length > 0 &&
                    props?.allMemberships.map((membership, index) => {
                      return (
                        <option value={membership.id} key={index}>
                          {membership.name}
                        </option>
                      );
                    })}
                </select>
              </div>
              {props?.loadingMemberships && (
                <div className="col-auto">
                  <div
                    className="spinner-border text-primary spinner-border-sm mt-3"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-12">
            <button type="submit" className="btn btn-primary text-white">
              {!saving && (
                <i className="fa fa-building-o" aria-hidden="true"></i>
              )}

              {saving && (
                <div
                  className="spinner-border text-white spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              <span className="ms-3">Add Organization</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddNewCompany;
